/* eslint-disable react/prop-types */

import React, { useState, useEffect } from 'react';
import {
  Col,
  Row,
  Table,
  Tabs,
  Input,
  Form,
  Modal,
  Paragraph,
  Item,
  PlusOutlined,
  CustomIcon,
  Checkbox,
  Search,
  SearchOutlined,
} from 'antd/index';
import tableShapeUsers from './TableShapeUsers/tableShapeUsers';
import tableShapeRoles from './TableShapeRoles/tableShapeRoles';
import tableShapeCategories from './TableShapeCategories/tableShapeCategories';
import messages from 'utils/validationSchemaOptions/validationSchemaOptions';
import paginationSetting from 'utils/paginationSetting';
import { string, bool, func, array } from 'prop-types';
import { isRoot } from 'utils/checkUserRoles';
import {
  SETTINGS_ACTIVE_TABS,
  EMAIL_REGEX,
  createUserEndpoint,
  SETTINGS_VIEW,
  PLACEHOLDERS,
  BUTTON_TEXTS,
} from 'constants/index';
import CustomSelect from '../../components/CustomSelect/CustomSelect';
import CustomButton from 'components/CustomButton/CustomButton';
import axios from 'axios';
import { showInfoMessage } from 'utils/showInfoMessage';
import tableShapeAccess from './tableShapeAccess';
import { accessRequestsCollectionRef, messageCollectionRef, rolesCollectionRef } from 'services/firestore/references';
import setCollectionDocument from 'utils/collectionDocumentCRUD/setCollectionDocument';
import getCollectionDocument from 'utils/collectionDocumentCRUD/getCollectionDocument';
import DeleteModal from 'components/DeleteModal/DeleteModal';

const { existEmailUser, validAddUser, invalidAddUser } = messages;
const {
  ADD_MESSAGE,
  USERS,
  SEARCH_USER,
  ADD,
  MESSAGE,
  ENTER_ROLE_NAME,
  ROLE_NAME,
  ACCESS,
  ADD_ACCESS,
  SELECT_ROLE,
  CATEGORIES,
  ENTER_CATEGORY_NAME,
  CATEGORY_NAME,
  ADD_USER,
  EMAIL,
  ROLE,
  TABS_LEAVES,
  COPIED_DATA,
  SELECT_PERMISSIONS,
} = SETTINGS_VIEW;
const { SELECT, ENTER, ENTER_CONTENT } = PLACEHOLDERS;
const { SAVE, CANCEL } = BUTTON_TEXTS;

const PlusSign = () => {
  return (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M0 12C0 5.37321 5.37321 0 12 0C18.6268 0 24 5.37321 24 12C24 18.6268 18.6268 24 12 24C5.37321 24 0 18.6268 0 12ZM11 7C11 6.44771 11.4477 6 12 6C12.5523 6 13 6.44772 13 7V11H17C17.5523 11 18 11.4477 18 12C18 12.5523 17.5523 13 17 13H13V17C13 17.5523 12.5523 18 12 18C11.4477 18 11 17.5523 11 17V13H7C6.44772 13 6 12.5523 6 12C6 11.4477 6.44772 11 7 11H11V7Z"
        fill="#616161"
      />
    </svg>
  );
};

const { enterEmailAddress, selectRole, tooLongText } = messages;
const initialsUsersPerPage = 7;
const initialsItemsPerPage = 8;
const initialPagesOfItems = 1;
const pageSizeOptions = [8, 16, 24];

const SettingsView = ({
  deleteUser,
  addRole,
  updateRole,
  dataUsers,
  roles,
  accessRequests,
  setReloadData,
  reloadData,
  roleCurrentUser,
  categories,
  addCategory,
  updateCategory,
  deleteCategory,
  userRolesForAdmin,
  userRolesForRoot,
  setIsLoading,
  activeKeyTab,
  setActiveKeyTab,
  rolesOptions,
}) => {
  const { TabPane } = Tabs;
  const [addUserForm] = Form.useForm();
  const memoizedNumberOfUsersPerPage = JSON.parse(localStorage.getItem('numberOfUsersPerPage'));
  const memoizedNumberOfRolesPerPage = JSON.parse(localStorage.getItem('numberOfRolesPerPage'));
  const memoizedNumberOfCategoriesPerPage = JSON.parse(localStorage.getItem('numberOfCategoriesPerPage'));
  const [numberOfUsersPerPage, setNumberOfUsersPerPage] = useState(
    memoizedNumberOfUsersPerPage || initialsUsersPerPage,
  );
  const [currentPageOfUsers, setCurrentPageOfUsers] = useState(initialPagesOfItems);
  const [numberOfRolesPerPage, setNumberOfRolesPerPage] = useState(
    memoizedNumberOfRolesPerPage || initialsItemsPerPage,
  );
  const [currentPageOfRoles, setCurrentPageOfRoles] = useState(initialPagesOfItems);
  const [numberOfCategoriesPerPage, setNumberOfCategoriesPerPage] = useState(
    memoizedNumberOfCategoriesPerPage || initialsItemsPerPage,
  );
  const [currentPageOfCategories, setCurrentPageOfCategories] = useState(initialPagesOfItems);
  const [isVisibleModalAddUser, setIsVisibleModalAddUser] = useState(false);
  const [isVisibleModalAddRole, setIsVisibleModalAddRole] = useState(false);
  const [categoryName, setCategoryName] = useState('');
  const [roleName, setRoleName] = useState('');
  const [isAccessCopiedData, setIsAccessCopiedData] = useState(false);
  const [isAccessTabsLeaves, setIsAccessTabsLeaves] = useState(false);
  const [isAccessWindowLeaves, setIsAccessWindowLeaves] = useState(false);
  const [isPossibleHiddenTest, setIsPossibleHiddenTest] = useState(false);
  const [filterUser, setFilterUser] = useState('');
  const [filteredDataUsers, setFilteredDataUsers] = useState([]);
  const [isAddAccessModalVisible, setIsAddAccessModalVisible] = useState(false);
  const [userAccessEmail, setUserAccessEmail] = useState('');
  const [userAccessId, setUserAccessId] = useState('');
  const [userAccessForm] = Form.useForm();
  const [messageInitialValue, setMessageInitialValue] = useState('');
  const [isModalDeleteVisible, setIsModalDeleteVisible] = useState(false);
  const [idClicked, setIdClicked] = useState(0);
  useEffect(() => {
    localStorage.setItem('numberOfUsersPerPage', JSON.stringify(numberOfUsersPerPage));
    localStorage.setItem('numberOfRolesPerPage', JSON.stringify(numberOfRolesPerPage));
    localStorage.setItem('numberOfCategoriesPerPage', JSON.stringify(numberOfCategoriesPerPage));
  }, [numberOfUsersPerPage, numberOfRolesPerPage, numberOfCategoriesPerPage]);

  const { id } = rolesCollectionRef.doc();

  useEffect(() => {
    const handleAsync = async () => {
      const { message } = await getCollectionDocument(messageCollectionRef, 'message');
      setMessageInitialValue(message);
    };

    handleAsync();
  }, []);

  const handleOnFinishAddMessage = async ({ message }) => {
    await setCollectionDocument(messageCollectionRef, { message }, 'message');
    showInfoMessage('success', `${ADD_MESSAGE}`);
  };
  const handleOnFinishAddNewUser = async values => {
    const { email } = values;
    const isExistEmailUser = dataUsers.some(({ email: existEmail }) => existEmail.trim() === email.trim());
    if (isExistEmailUser) {
      showInfoMessage('error', existEmailUser);
      return;
    }
    setIsLoading(true);

    const { data } = await axios.post(createUserEndpoint, values);
    if (data === 'ok') {
      showInfoMessage('success', validAddUser);
      setReloadData(prev => !prev);
      setIsLoading(false);
    } else {
      showInfoMessage('error', invalidAddUser);
      setIsLoading(false);
      return;
    }
  };

  const changeActiveTab = activeTab => {
    setActiveKeyTab(activeTab);
  };

  const hideModalAddUser = () => {
    addUserForm.resetFields();
    setIsVisibleModalAddUser(false);
  };

  const hideModalAddRole = () => {
    setIsVisibleModalAddRole(false);
  };

  const savePermissions = permissions => {
    const { isAccessCopiedData, isAccessTabsLeaves, isAccessWindowLeaves, isPossibleHiddenTest } = permissions;
    setIsAccessCopiedData(isAccessCopiedData);
    setIsAccessTabsLeaves(isAccessTabsLeaves);
    setIsAccessWindowLeaves(isAccessWindowLeaves);
    setIsPossibleHiddenTest(isPossibleHiddenTest);
    hideModalAddRole();
  };

  const handleOnFinishAddAccess = async ({ role }) => {
    setIsLoading(true);
    const values = {
      role,
      email: userAccessEmail,
    };

    try {
      const { data } = await axios.post(createUserEndpoint, values);

      if (data === 'ok') {
        await accessRequestsCollectionRef.doc(userAccessId).delete();
        userAccessForm.resetFields();
        setIsAddAccessModalVisible(prev => !prev);
        showInfoMessage('success', validAddUser);
        setIsLoading(false);
      }
    } catch (e) {
      showInfoMessage('error', invalidAddUser);
      setIsLoading(false);
    }
  };

  useEffect(() => {
    const filteredDataUsers = dataUsers.filter(user => {
      const { email } = user;
      if (email.toLowerCase().includes(filterUser.toLowerCase())) {
        return user;
      }
    });
    setFilteredDataUsers(filteredDataUsers);
  }, [filterUser]);

  const handleDeleteAccessItem = id => {
    accessRequestsCollectionRef.doc(id).delete();
  };

  return (
    <Row justify="center" align="middle" className="settings-container table">
      <Col className="settings-container__col">
        <Tabs
          activeKey={activeKeyTab}
          animated={{ inkBar: false, tabPane: false }}
          onChange={activeTab => changeActiveTab(activeTab)}
        >
          <TabPane tab={USERS} key={SETTINGS_ACTIVE_TABS.USERS} className="tab-pane-users">
            <Modal
              footer={null}
              title={ADD_USER}
              visible={isVisibleModalAddUser}
              onCancel={hideModalAddUser}
              className="modal-in-settings"
              closable={false}
              centered
            >
              <Form
                form={addUserForm}
                requiredMark="optional"
                layout="vertical"
                className="container__form form"
                onFinish={handleOnFinishAddNewUser}
                autoComplete="off"
              >
                <Item
                  className="form-item form__item"
                  label={<Paragraph className="form-item__label">{EMAIL}</Paragraph>}
                  rules={[
                    {
                      whitespace: true,
                      required: true,
                      message: enterEmailAddress,
                      pattern: new RegExp(EMAIL_REGEX),
                    },
                    {
                      max: 100,
                      message: tooLongText,
                    },
                  ]}
                  name="email"
                >
                  <Input className="form-item__input" placeholder={ENTER} autoComplete="off" />
                </Item>
                <Item
                  className="form__item"
                  label={<Paragraph className="form-item__label">{ROLE}</Paragraph>}
                  rules={[
                    {
                      required: true,
                      message: selectRole,
                    },
                  ]}
                  name="role"
                >
                  <CustomSelect
                    options={isRoot(roleCurrentUser) ? userRolesForRoot : userRolesForAdmin}
                    placeholder={SELECT}
                    isSingle={true}
                  />
                </Item>
                <Row className="action-container" justify="space-around">
                  <CustomButton onClick={hideModalAddUser} className="custom-button--resign">
                    {CANCEL}
                  </CustomButton>
                  <CustomButton type="primary" htmlType="submit" className="custom-button--green">
                    <PlusOutlined />
                    {ADD_USER}
                  </CustomButton>
                </Row>
              </Form>
            </Modal>
            <Search
              placeholder={SEARCH_USER}
              className="input-search"
              value={filterUser}
              maxLength={100}
              onChange={e => setFilterUser(e.target.value)}
              prefix={<SearchOutlined />}
            />
            <Table
              rowKey="id"
              rowClassName="users-table-row tr th:nth-child"
              dataSource={filteredDataUsers}
              columns={tableShapeUsers(
                roleCurrentUser,
                setReloadData,
                reloadData,
                deleteUser,
                userRolesForAdmin,
                userRolesForRoot,
                setIsLoading,
                setIsVisibleModalAddUser,
              )}
              pagination={paginationSetting(
                numberOfUsersPerPage,
                currentPageOfUsers,
                setCurrentPageOfUsers,
                true,
                setNumberOfUsersPerPage,
              )}
            />
          </TabPane>
          {isRoot(roleCurrentUser) && (
            <TabPane tab={MESSAGE} key={'message'} className="tab-pane-multiple-row">
              <Form
                initialValues={{ message: messageInitialValue }}
                onFinish={handleOnFinishAddMessage}
                className="add-item-container"
                autoComplete="off"
              >
                <Item className="add-item-container__item" name="message">
                  <Input placeholder={ENTER_CONTENT} className="add-item-container__input" autoComplete="off" />
                </Item>
                <CustomButton className="reset-button add-item-container__paragraph" htmlType="submit">
                  {ADD}
                  <CustomIcon className="add-question-button" component={PlusSign} />
                </CustomButton>
              </Form>
            </TabPane>
          )}
          {isRoot(roleCurrentUser) && (
            <TabPane tab="Role" key={SETTINGS_ACTIVE_TABS.ROLES} className="tab-pane-multiple-row">
              <Modal
                footer={null}
                title={SELECT_PERMISSIONS}
                visible={isVisibleModalAddRole}
                onCancel={hideModalAddRole}
                closable={false}
                className="modal-in-settings"
                centered
              >
                <Form autoComplete="off" onFinish={savePermissions}>
                  <Row className="form-item form__item form__item--checkbox">
                    <Item initialValue={false} valuePropName="checked" name="isAccessTabsLeaves" noStyle>
                      <Checkbox>{TABS_LEAVES}</Checkbox>
                    </Item>
                  </Row>
                  <Row className="form-item form__item form__item--checkbox">
                    <Item initialValue={false} valuePropName="checked" name="isAccessCopiedData" noStyle>
                      <Checkbox>{COPIED_DATA}</Checkbox>
                    </Item>
                  </Row>
                  <Row className="action-container action-container--center">
                    <CustomButton type="primary" htmlType="submit" className="custom-button--green">
                      {SAVE}
                    </CustomButton>
                  </Row>
                </Form>
              </Modal>
              <Table
                rowKey="id"
                columns={tableShapeRoles(updateRole)}
                dataSource={roles}
                pagination={paginationSetting(
                  numberOfRolesPerPage,
                  currentPageOfRoles,
                  setCurrentPageOfRoles,
                  true,
                  setNumberOfRolesPerPage,
                  pageSizeOptions,
                )}
              />
            </TabPane>
          )}
          {isRoot(roleCurrentUser) && (
            <TabPane tab={ACCESS} key={SETTINGS_ACTIVE_TABS.ACCESS} className="tab-pane-multiple-row">
              <Modal
                footer={null}
                title={ADD_ACCESS}
                visible={isAddAccessModalVisible}
                closable={true}
                onCancel={() => {
                  setIsAddAccessModalVisible(prev => !prev);
                  userAccessForm.resetFields();
                }}
                className="modal-in-settings example-modal"
                centered
              >
                <Form
                  className="example-form"
                  form={userAccessForm}
                  style={{ padding: 20 }}
                  onFinish={handleOnFinishAddAccess}
                  autoComplete="off"
                >
                  <Item
                    rules={[
                      {
                        whitespace: true,
                        required: true,
                        message: SELECT_ROLE,
                      },
                    ]}
                    style={{ marginBottom: 30 }}
                    name="role"
                  >
                    <CustomSelect isSingle={true} placeholder={SELECT_ROLE} options={rolesOptions} />
                  </Item>
                  <Row justify="end">
                    <CustomButton htmlType="submit" className="custom-button--green">
                      {SAVE}
                    </CustomButton>
                  </Row>
                </Form>
              </Modal>
              <DeleteModal
                isModalDeleteVisible={isModalDeleteVisible}
                setIsModalDeleteVisible={setIsModalDeleteVisible}
                deleteFunc={handleDeleteAccessItem}
                id={idClicked}
              />
              <Table
                className="access-requests-table"
                rowKey="accessTableId"
                columns={tableShapeAccess(
                  setIsModalDeleteVisible,
                  setIdClicked,
                  setIsAddAccessModalVisible,
                  setUserAccessEmail,
                  setUserAccessId,
                  isModalDeleteVisible,
                )}
                dataSource={accessRequests}
                locale={{ emptyText: 'No data' }}
                pagination={paginationSetting(
                  numberOfRolesPerPage,
                  currentPageOfRoles,
                  setCurrentPageOfRoles,
                  true,
                  setNumberOfRolesPerPage,
                  pageSizeOptions,
                )}
              />
            </TabPane>
          )}
          {isRoot(roleCurrentUser) && (
            <TabPane
              tab={CATEGORIES}
              key={SETTINGS_ACTIVE_TABS.CATEGORIES}
              className="tab-pane-multiple-row tab-pane-multiple-categories-row"
            >
              <Form autoComplete="off" className="add-item-container">
                <Item
                  className="add-item-container__item"
                  name="categoryName"
                  rules={[
                    {
                      whitespace: true,
                      required: true,
                      message: ENTER_CATEGORY_NAME,
                    },
                  ]}
                >
                  <Input
                    placeholder={CATEGORY_NAME}
                    className="add-item-container__input"
                    maxLength="35"
                    autoComplete="off"
                    onChange={event => setCategoryName(event.target.value)}
                  />
                </Item>
                <Paragraph className="add-item-container__paragraph">{ADD}</Paragraph>
                <CustomIcon
                  onClick={
                    categoryName.trim()
                      ? () => {
                          setIsLoading(true);
                          addCategory(categoryName);
                        }
                      : null
                  }
                  className={categoryName.trim() ? 'add-question-button selected' : 'add-question-button'}
                  component={PlusSign}
                />
              </Form>
              <DeleteModal
                isModalDeleteVisible={isModalDeleteVisible}
                setIsModalDeleteVisible={setIsModalDeleteVisible}
                deleteFunc={deleteCategory}
                setIsLoading={setIsLoading}
                id={idClicked}
              />
              <Table
                rowKey={category => category}
                columns={tableShapeCategories(
                  updateCategory,
                  deleteCategory,
                  categories,
                  setIsModalDeleteVisible,
                  setIdClicked,
                )}
                dataSource={categories}
                pagination={paginationSetting(
                  numberOfCategoriesPerPage,
                  currentPageOfCategories,
                  setCurrentPageOfCategories,
                  true,
                  setNumberOfCategoriesPerPage,
                  pageSizeOptions,
                )}
              />
            </TabPane>
          )}
        </Tabs>
      </Col>
    </Row>
  );
};
SettingsView.propTypes = {
  deleteUser: func,
  addRole: func,
  dataUsers: array,
  addNewUser: func,
  roles: array,
  updateRole: func,
  setReloadData: func,
  reloadData: bool,
  roleCurrentUser: string,
  categories: array,
  addCategory: func,
  updateCategory: func,
  deleteCategory: func,
  userRolesForAdmin: array,
  userRolesForRoot: array,
  setIsLoading: func,
  activeKeyTab: string,
  setActiveKeyTab: func,
};
export default SettingsView;
